import { createAction } from "@reduxjs/toolkit";
import { SupportedLocale } from "constants/locales";

export const logout = createAction('user/logout');
export const updateUserLocale = createAction<{ userLocale: SupportedLocale }>('user/updateUserLocale');